import { colors } from '~/styles/colors';

type SearchIconProps = {
  color?: string;
  size?: number;
}

export const SearchNewIcon = ({ color = colors.icon['sub-500'], size }: SearchIconProps): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size ?? 18}
    height={size ?? 18}
    fill="none"
    viewBox="0 0 18 18"
  >
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="m16.5 16.5-5-5m1.667-4.167a5.833 5.833 0 1 1-11.667 0 5.833 5.833 0 0 1 11.667 0"
    />
  </svg>
);
